import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

//import images
import Avatar from "../../components/common/Avatar";
import { useProfile } from "features/Authentication/hooks/useProfile";

const ProfileDropdown = () => {
  const { user, isSuperAdmin, highestRole } = useProfile();

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <div className="header-profile-user flex-shrink-0 overflow-hidden">
              <Avatar
                name={`${user?.firstName ?? ""} ${user?.lastName ?? ""}`}
                image={user?.avatar}
              />
            </div>
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {`${user?.firstName} ${user?.lastName}`}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {highestRole?.name}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">
            Welcome {`${user?.firstName} ${user?.lastName}`}!
          </h6>
          {user?.employee?.id != null && (
            <>
              <DropdownItem className="p-0">
                <Link
                  to={`/employees/${user.employee.id}`}
                  className="dropdown-item"
                >
                  <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                  <span className="align-middle">Profile</span>
                </Link>
              </DropdownItem>
              <div className="dropdown-divider"></div>
            </>
          )}

          {isSuperAdmin && (
            <DropdownItem className="p-0">
              <Link to="/settings" className="dropdown-item">
                <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
                <span className="align-middle">Settings</span>
              </Link>
            </DropdownItem>
          )}

          <DropdownItem className="p-0">
            <Link to="/logout" className="dropdown-item">
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle" data-key="t-logout">
                Logout
              </span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
